export interface MetadataValues {
  sourceLabel: string;
  sourceUrl: string;
  purchaseCost: string;
  purchaseDate: string;
  sellerAge: string;
  countryCode: string;
}

export const emptyMetadata: MetadataValues = {
  sourceLabel: "",
  sourceUrl: "",
  purchaseCost: "",
  purchaseDate: "",
  sellerAge: "",
  countryCode: "",
};
